/**
 * @generated SignedSource<<4f411c0e09ffeae1aae8e9833b4787f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentTypeEnum = "ATTACHMENT" | "DITTO_VIDEOS" | "GRAPHQL_DOCUMENT" | "PAGE" | "POST" | "ZNGLIST" | "ZNGLY_INFO";
export type OrderEnum = "ASC" | "DESC";
export type UserRoleEnum = "ADMIN" | "ADMINISTRATOR" | "GUEST" | "SALES_USER" | "SALES_USER__RESTRICTED_" | "USER";
export type UsersConnectionOrderbyEnum = "DISPLAY_NAME" | "EMAIL" | "LOGIN" | "LOGIN_IN" | "NICE_NAME" | "NICE_NAME_IN" | "REGISTERED" | "URL";
export type UsersConnectionSearchColumnEnum = "EMAIL" | "ID" | "LOGIN" | "NICENAME" | "URL";
export type RootQueryToUserConnectionWhereArgs = {
  exclude?: ReadonlyArray<number | null | undefined> | null | undefined;
  hasPublishedPosts?: ReadonlyArray<ContentTypeEnum | null | undefined> | null | undefined;
  include?: ReadonlyArray<number | null | undefined> | null | undefined;
  login?: string | null | undefined;
  loginIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  loginNotIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  nicename?: string | null | undefined;
  nicenameIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  nicenameNotIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  orderby?: ReadonlyArray<UsersConnectionOrderbyInput | null | undefined> | null | undefined;
  role?: UserRoleEnum | null | undefined;
  roleIn?: ReadonlyArray<UserRoleEnum | null | undefined> | null | undefined;
  roleNotIn?: ReadonlyArray<UserRoleEnum | null | undefined> | null | undefined;
  search?: string | null | undefined;
  searchColumns?: ReadonlyArray<UsersConnectionSearchColumnEnum | null | undefined> | null | undefined;
};
export type UsersConnectionOrderbyInput = {
  field: UsersConnectionOrderbyEnum;
  order?: OrderEnum | null | undefined;
};
export type Users_Query$variables = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  where?: RootQueryToUserConnectionWhereArgs | null | undefined;
};
export type Users_Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Users_Pagination_Fragment">;
};
export type Users_Query = {
  response: Users_Query$data;
  variables: Users_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": 24,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "where"
},
v3 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "Users_Query",
    "selections": [
      {
        "args": (v3/*: any*/),
        "kind": "FragmentSpread",
        "name": "Users_Pagination_Fragment"
      }
    ],
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "Users_Query",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "RootQueryToUserConnection",
        "kind": "LinkedField",
        "name": "users",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RootQueryToUserConnectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "role",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "username",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nicename",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "size",
                        "value": 10
                      }
                    ],
                    "concreteType": "Avatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/)
                    ],
                    "storageKey": "avatar(size:10)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User_Meta",
                    "kind": "LinkedField",
                    "name": "meta",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "jobRole",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MediaItem",
                        "kind": "LinkedField",
                        "name": "profileImage",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mediaItemUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mimeType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MediaDetails",
                            "kind": "LinkedField",
                            "name": "mediaDetails",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MediaSize",
                                "kind": "LinkedField",
                                "name": "sizes",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sourceUrl",
                                    "storageKey": null
                                  },
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User_Meta_profileSocialLinks",
                        "kind": "LinkedField",
                        "name": "profileSocialLinks",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User_Meta_profileArticleLinks",
                        "kind": "LinkedField",
                        "name": "profileArticleLinks",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "iconName",
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nickname",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "capabilities",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RootQueryToUserConnectionPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "filters": [
          "where"
        ],
        "handle": "connection",
        "key": "Users_query_users",
        "kind": "LinkedHandle",
        "name": "users"
      }
    ]
  },
  "params": {
    "cacheID": "d6df8ce808178a6b09f7d060cbb9fc21",
    "id": null,
    "metadata": {},
    "name": "Users_Query",
    "operationKind": "query",
    "text": "query Users_Query(\n  $first: Int = 24\n  $after: String\n  $where: RootQueryToUserConnectionWhereArgs\n) {\n  ...Users_Pagination_Fragment_3sueo6\n}\n\nfragment Users_Pagination_Fragment_3sueo6 on RootQuery {\n  users(first: $first, after: $after, where: $where) {\n    edges {\n      node {\n        id\n        slug\n        role\n        username\n        name\n        nicename\n        avatar(size: 10) {\n          url\n        }\n        meta {\n          jobRole\n          profileImage {\n            id\n            mediaItemUrl\n            mimeType\n            mediaDetails {\n              sizes {\n                sourceUrl\n                name\n              }\n            }\n            description\n          }\n          profileSocialLinks {\n            name\n            url\n          }\n          profileArticleLinks {\n            name\n            iconName\n            url\n          }\n        }\n        nickname\n        firstName\n        lastName\n        description\n        email\n        capabilities\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f98e41d8889edae37714a92dad96273d";

export default node;
